import { render, staticRenderFns } from "./ServiceHome.vue?vue&type=template&id=88be0d14&scoped=true"
import script from "./ServiceHome.vue?vue&type=script&lang=js"
export * from "./ServiceHome.vue?vue&type=script&lang=js"
import style0 from "./ServiceHome.vue?vue&type=style&index=0&id=88be0d14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88be0d14",
  null
  
)

export default component.exports